import React, { useState } from 'react';
import { Heading, Button } from 'mondrian-react';
import { useJourney } from '~/hooks/journey';

import logoClaro from '../../assets/images/logo-claro.svg';
import duvidas from '../../assets/images/duvidas-dark-color.png';

import { Header, ModalFaq, ModalPrivacidade } from './styles';

export function HeaderBar() {
  const { urlInitBase, hideHeader } = useJourney();
  const [showFaq, setShowFaq] = useState(false);
  const [showPrivacidade, setShowPrivacidade] = useState(false);

  function handleClickDuvidas(e: React.MouseEvent) {
    e.preventDefault();
    setShowFaq(true);
  }

  function handleClickCadeado(e: React.MouseEvent) {
    e.preventDefault();
    setShowPrivacidade(true);
  }

  if (hideHeader) {
    return null;
  }
  return (
    <Header brandHref={urlInitBase} brandSrc={logoClaro} style={{ zIndex: 1 }}>
      <a
        href="/"
        className="cadeado"
        data-gtm-event-category="claro:cadastro-pre-pago:header"
        data-gtm-event-action="clique:link"
        data-gtm-event-label="tire-suas-duvidas"
        onClick={e => handleClickCadeado(e)}
      >
        <span className="mdn-Icon-senha mdn-Icon--md" />
      </a>
      <a
        href="/"
        data-gtm-event-category="claro:cadastro-pre-pago:header"
        data-gtm-event-action="clique:link"
        data-gtm-event-label="tire-suas-duvidas"
        onClick={e => handleClickDuvidas(e)}
      >
        <img src={duvidas} alt="Logotipo de duvidas" />
      </a>
      {showFaq && (
        <ModalFaq
          sm
          data={{
            header: <Heading>Perguntas frequentes</Heading>,
            content: (
              <div className="content-modal-faq">
                <Heading xs>
                  Respondemos suas principais dúvidas sobre o cadastro:
                </Heading>

                <Button
                  block
                  onClick={() => {
                    window.open(
                      'https://www.claro.com.br/cadastro-pre',
                      '_blank',
                    );
                  }}
                >
                  Clique e confira
                </Button>
              </div>
            ),
            onCloseClick: () => setShowFaq(false),
            isOpen: true,
          }}
        />
      )}
      {showPrivacidade && (
        <ModalPrivacidade
          sm
          data={{
            header: <Heading>Privacidade e Segurança</Heading>,
            content: (
              <div className="content-modal-faq">
                <Heading xs>Entenda como protegemos suas informações:</Heading>

                <Button
                  block
                  onClick={() => {
                    window.open(
                      'https://www.claro.com.br/privacidade/politica-de-privacidade',
                      '_blank',
                    );
                  }}
                >
                  Portal de privacidade
                </Button>
                <Button
                  block
                  onClick={() => {
                    window.open(
                      'https://www.claro.com.br/privacidade',
                      '_blank',
                    );
                  }}
                >
                  Política de privacidade
                </Button>
              </div>
            ),
            onCloseClick: () => setShowPrivacidade(false),
            isOpen: true,
          }}
        />
      )}
    </Header>
  );
}
